import { WholesaleSupplierPopover } from './wholesale-supplier.popover';
import { StringHelper } from 'app/utility/stringhelper';
import { MenuService } from 'app/services/menu.service';
import { parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js';
import { WholesaleSupplierModel } from 'app/models/wholesale/wholesaleSupplier.model';

import { WholesaleService } from 'app/services/wholesale.service';
import { WholesaleVehicleModel } from 'app/models/wholesale/wholesaleVehicle.model';
import { OpportunityActivityResultModel } from 'app/models/dms/opportunityActivityResult.model';
import { GeneralService } from 'app/services/general.service';
import { EditorPageComponent } from 'app/components/shared/editor-page/editor-page.component';

import { FieldModel } from 'app/models/shared/field.model';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { TabModel } from 'app/models/shared/tab.model';

import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UserService } from 'app/services/user.service';

import { PopoverController, AlertController, ActionSheetController, LoadingController, NavController, ModalController, IonContent, Config, Platform } from '@ionic/angular';

import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { StorageService } from 'app/services/storage.service';
import { Location } from '@angular/common';
import { ExportService } from 'app/services/export.service';


import { DecimalPipe } from '@angular/common';
import { Browser } from '@capacitor/browser';

import { Share } from '@capacitor/share';

import { Constants } from 'app/utility/constants';
import { DateHelper } from 'app/utility/datehelper';


@Component({
    selector: 'app-wholesale-supplier',
    templateUrl: './wholesale-supplier.page.html',
    styleUrls: ['./wholesale-supplier.page.scss'],
    standalone: false
})
export class WholesaleSupplierPage extends EditorPageComponent implements OnInit
{

	public supplier: WholesaleSupplierModel;
	public calculatedImageHeight: number;
	public gradient: boolean = false;
	navigating: boolean = false;

	constructor(
		public wholesaleService: WholesaleService,
		public userService: UserService,
		public route: ActivatedRoute,
		public titleService: Title,
		public storage: StorageService,
		public alertController: AlertController,
		public popoverController: PopoverController,
		public actionSheetController: ActionSheetController,
		public loadingController: LoadingController,
		public modalController: ModalController,
		public navCtrl: NavController,
		protected cd: ChangeDetectorRef,
		public platform: Platform,
		protected location: Location,
		protected generalService: GeneralService,
		protected config: Config,
		protected exportService: ExportService,
		protected decimalPipe: DecimalPipe,
		private menuService: MenuService
	)
	{
		super(userService, route, titleService, storage, alertController, popoverController, actionSheetController, loadingController, cd, platform);
	}

	actionLaunched: boolean = false;
	vehicle_slider_size_2: number = 150;
	vehicle_slider_height_2: number = 200;
	canViewActivities: boolean = true;
	showGallery: boolean = false;
	showMakeOffer: boolean = false;

	defaultHref: string;
	noImageUrl: string;

	initials: string = "-";

	@ViewChild(IonContent) content: IonContent;

	mcOnInit()
	{
		this.defaultHref = "/wholesale/vehicles/suppliers";

		this.title = "Supplier";

		this.calculatedImageHeight = (Math.round(window.innerWidth * 0.75));

		this.vehicle_slider_height_2 = this.calculatedImageHeight;

		if (this.calculatedImageHeight < 75)
		{
			this.calculatedImageHeight = 75;
		}
		if (this.calculatedImageHeight > 400)
		{
			this.calculatedImageHeight = 400;
		}

		this.slideOpts = {
			// autoHeight: true
			zoom: {
				maxRatio: 5,
			},
			roundLengths: true,
			centeredSlides: true,
			dynamicBullets: true,
			dynamicMainBullets: 10,
			height: this.calculatedImageHeight,
			lazy: true,
		};

		this.noImageUrl = Constants.PlaceholderCarUrl;
		this.menuService.setArea("wholesale");

		this.title = 'Supplier vehicles';
	}

	mcOnDestroy() { }

	mcViewDidEnter()
	{

		this.fetchObject();
	}
	public imageIsReloading: boolean = false;


	public getPageName(): string
	{
		return (this.supplier) ? this.supplier.dealershipTradingName ? this.supplier.dealershipTradingName : this.supplier.dealershipName : "Supplier";
	}

	public fetchTemplate()
	{
	}

	fetchingObject: boolean = false;
	public fetchObject()
	{
		if (this.fetchingObject) return;
		this.fetchingObject = true;

		this.wholesaleService.getCachedSupplierById(this.id)
			.subscribe
			({
				next: x =>
				{
					// console.log(x);
					this.supplier = x;
					this.skeleton = false;
					this.fetchingObject = false;

					this.gradient = true;

					this.setupTitle();
					this.setupFieldGroups();
					this.setTabHeights();
					this.setCanEmail();
					this.setPhoneIsValid();
					this.initials = this.getInitials(this.getPageName());
					this.setContactColourClass(this.getPageName());

					if (this.supplier && this.supplier.dealershipID)
					{
						this.id = "" + this.supplier.dealershipID;
					}

					this.setupImages();
				},
				error: err =>
				{
					this.handleError(err, false);
					this.fetchingObject = false;
					this.skeleton = false;
				}
			});
	}

	public getInitials(name: string = ''): string
	{
		return StringHelper.getInitials(name);
	}

	contactColourClass: string;
	setContactColourClass(name: string = ''): void
	{
		let initial = '';
		let className = '';
		let checkName = name ? (name) : '';

		if (checkName.length > 0)
		{
			initial = checkName[0].toLowerCase();
		}

		if (!(/^[a-z]$/.test(initial)))
		{
			initial = '';
		}

		if (initial === '')
		{
			initial = '0';
		}

		this.contactColourClass = 'contact-class-' + initial;
	}

	public lastActivity: OpportunityActivityResultModel;
	public lastActivityLoading: boolean = false;

	public async saveObject()
	{
	}



	public getPopoverComponent(menu: string = ''): any
	{
		switch (menu)
		{
			default:
				return WholesaleSupplierPopover;
		}

	}

	public async popoverDismissed(data: any)
	{
		switch (data.data)
		{
			case "vehicles":
				this.loadVehicles();
				break;
			default:
				// console.log("popover dismissed", data.data);
				break;
		}
	}

	imageUrls: string[];

	private loadVehicles()
	{
		this.navCtrl.navigateForward('wholesale/suppliers/' + this.id + '/vehicles');
	}

	setupImages()
	{
	}

	imageSliderConfig = {
		'slide': 'li',
		'arrows': false
	};

	slideOpts = {
		// autoHeight: true
		zoom: {
			maxRatio: 5,
		},
		roundLengths: true,
		centeredSlides: true,
		dynamicBullets: true,
		dynamicMainBullets: 10,
		height: 200,
		lazy: true,
	};

	public numberWithCommas(x: any): string
	{
		return StringHelper.numberWithCommas(x);
	}


	public setupFieldGroups(makeDirty: boolean = false): void
	{

		this.editActive = false;

		this.fieldGroupTabs = [];

		this.fieldGroupTabs.push(new TabModel("Summary", this.supplier, this.getFieldGroups("summary"), makeDirty, "summary", "", true, false));
		this.fieldGroupTabs.push(new TabModel("Contact", this.supplier, this.getFieldGroups("contact"), makeDirty, "contact", "", true, false));
	}

	public getFieldGroups(groupId: string): FieldGroupModel[]
	{
		var field_groups: FieldGroupModel[] = [];
		var field_group: FieldGroupModel;
		switch (groupId)
		{
			case 'summary':
				field_group = new FieldGroupModel('');
				field_group.addField(new FieldModel("Address 1", this.supplier.address1));
				field_group.addField(new FieldModel("Address 2", this.supplier.address2));
				field_group.addField(new FieldModel("Suburb", this.supplier.suburb));
				field_group.addField(new FieldModel("City", this.supplier.city));
				field_group.addField(new FieldModel("Postcode", this.supplier.postCode));
				field_group.addField(new FieldModel("Region", this.supplier.regionCaption));
				field_group.addField(new FieldModel("Country", this.supplier.country.countryName));
				field_groups.push(field_group);
				break;
			case 'contact':
				field_group = new FieldGroupModel('');
				field_group = new FieldGroupModel('');
				field_group.addField(new FieldModel("Phone", this.supplier.phone1));
				field_group.addField(new FieldModel("Email", this.supplier.emailAddress, 'email'));
				field_groups.push(field_group);
				break;
		}
		return field_groups;
	}



	public getFormattedDate(date: Date)
	{
		return DateHelper.getFormattedDate(date);
	}

	async doShare(website: string)
	{
		let newVariable = (window.navigator as any)
		if (newVariable.share)
		{
			let shareRet = await Share.share({
				title: this.title,
				text: this.title,
				url: website,
				dialogTitle: 'Share dealer website address'
			});
		}
		else
		{
			await Browser.open({ url: website }); {
			}
		}
	}


	shortlistSaving: boolean = false;
	shortlist()
	{
		var status = !this.supplier.preferredSupplier;

		if (!this.shortlistSaving)
		{
			this.shortlistSaving = true;
			this.wholesaleService.favouriteSupplier(this.supplier.dealershipID, status).subscribe({
				next: x =>
				{
					this.supplier.preferredSupplier = x.value;
					this.shortlistSaving = false;
					this.wholesaleService.presentToast(status ? "Seller added as a preferred seller" : "Seller removed from preferred sellers", status ? "secondary" : "medium", "bottom");
				},
				error: err =>
				{
					this.shortlistSaving = false;
					this.wholesaleService.handleError(err);
				}
			});
		}

	}


	phoneIsValid: boolean = false;
	setPhoneIsValid(): void
	{
		var phone = this.supplier.phone1;
		this.phoneIsValid = this.checkPhoneIsValid(phone);
	}

	private checkPhoneIsValid(phone: string): boolean
	{
		if (!phone)
		{
			return false;
		}
		else
		{
			var phoneNumber = parsePhoneNumberFromString(phone, "NZ");
			return phoneNumber.isValid();
		}
	}

	canEmail: boolean = false;
	setCanEmail(): void
	{
		if (this.supplier.emailAddress)
		{
			var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
			this.canEmail = re.test(String(this.supplier.emailAddress.toLowerCase()));
		}
	}
	async openMenuItem(menuItem: string)
	{
		var phoneNumber: PhoneNumber;

		switch (menuItem)
		{
			case "call":
			case "mobile":
				if (this.checkPhoneIsValid(this.supplier.phone1))
				{
					var phoneNumber = parsePhoneNumberFromString(this.supplier.phone1, "NZ");
					if (phoneNumber.isValid())
					{
						window.location.href = phoneNumber.getURI();
					}
				}
				break;

			// case "text":
			// case "sms":
			// 	if (this.checkPhoneIsValid(this.contact.contactSummary.mobile))
			// 	{
			// 		phoneNumber = parsePhoneNumberFromString(this.contact.contactSummary.mobile, "NZ");
			// 		window.location.href = 'sms:' + phoneNumber.formatInternational();
			// 	}
			// 	break;
			case "email":
				if (this.supplier.emailAddress && this.canEmail)
				{
					window.location.href = 'mailto:' + this.supplier.emailAddress;
				}
			case "vehicles":
				this.loadVehicles();
				break;
		}
	}

	public segmentChanged(ev: any)
	{
		// console.log(ev);
		if (ev.detail.value=='vehicles') {
			this.navigating = true;
			setTimeout(() => {
				this.activeSegment = 'summary';
				this.navigating = false;
				this.loadVehicles();
			}, 0);

			return;
		}
		this.activeSegment = ev.detail.value;
		this.setTabHeights();
	}
}
